import type { DirTeamType, WarehouseInfo } from '@econtractor/types';
import vconst from 'utils/helpers/structs/vconst';
import { isActiveTeamWarehouse } from 'utils/helpers/teams/isTeamActive';
import { isActiveCustomWarehouse } from 'utils/helpers/warehouses/isCustomWarehouseActive';

export const getTelegramWarehouses = (warehouses: WarehouseInfo[], teams?: DirTeamType[]): WarehouseInfo[] => {
    // Object and reserve movements use object Telegram events instead.
    const baseWarehouses = warehouses.filter((wh) => {
        if (Number(wh.objectId) || Number(wh.reservObjectId)) return false;
        if (wh.ID === vconst.waherouseMainId || wh.ID === vconst.waherouseWriteOffId) return true;
        if (Number(wh.customId) > 0) return isActiveCustomWarehouse(wh);
        return Number(wh.teamId) > 0 && isActiveTeamWarehouse(wh, teams);
    });

    return [
        ...baseWarehouses.filter((wh) => wh.ID === vconst.waherouseMainId),
        ...baseWarehouses.filter((wh) => wh.ID === vconst.waherouseWriteOffId),
        ...baseWarehouses.filter((wh) => ![vconst.waherouseMainId, vconst.waherouseWriteOffId].includes(wh.ID)),
    ];
};
